module.exports = __webpack_public_path__ + "static/media/2122-service-2-2-min.0aa2d20b.jpg";